<template>
    <div class="quagga-wrapper">
        <h1>quagga-wrapper</h1>
        <p>quagga-init: {{quaggaInit}}</p>
        <p>quagga-start: {{quaggaStart}}</p>
        <p>quagga-stop: {{quaggaStop}}</p>
        <img src="@/assets/img/barcode.gif" alt="">
        <div id="yourElement"></div>
    </div>

</template>

<script>
import Quagga from 'quagga';
require("@/assets/img/barcode.gif")
export default {
    name: "quagga-micha",
    data: function(){
        return{
            quaggaInit: 'quagga-no-init',
            quaggaStart: 'no-start',
            quaggaStop: 'no-stop',
        }
    },
    mounted:function(){
        Quagga.init({
            inputStream : {
                name : "Live",
                type : "LiveStream",
                target: document.querySelector('#yourElement')    // Or '#yourElement' (optional)
            },
            decoder : {
                readers : ["code_128_reader"]
            }
        }, function(err) {
            if (err) {
                window.console.log(err);
                return
            }
            window.console.log("Initialization finished. Ready to start");
            this.quaggaInit = "Initialization finished. Ready to start";
            // Quagga.start();
        });

        // Quagga.decodeSingle({
        //     decoder: {
        //         readers: ["code_128_reader"] // List of active readers
        //     },
        //     locate: true, // try to locate the barcode in the image
        //     src: '/test/fixtures/code_128/image-001.jpg' // or 'data:image/jpg;base64,' + data
        // }, function(result){
        //     if(result.codeResult) {
        //         window.console.log("result", result.codeResult.code);
        //     } else {
        //         window.console.log("not detected");
        //     }
        // });
    }
};

</script>
